export default "__VITE_ASSET__CKbqX9di__"